import React from 'react';
import PageContainer from "../../../hoc/PageContainer";

const RegularMeeting = () => (
    <div>
        <PageContainer page="RegularMeeting">
            <h1 className="AboutUsTitle">WHAT HAPPENS AT A ROTARY MEETING?</h1>
            <div className="AboutUsText">
                <div className="center-container">
                    <img className="rotary-club-image" src="/imgs/gi/regularmeeting.jpg"/>
                </div>
                We are a group of local young professional who meet over dinner to hear from guest speakers on a wide variety of subjects and to plan events that will benefit communities both here and abroad, all whilst enjoying the company of good friends.
                <br/>
                <br/>
                Our Meetings on Wednesday at <b>The Chinese General Chamber of Commerce.</b>
                <br/>
                <br/>
                Meeting time: <b>07:30PM – 09:30 PM</b>
                <br/>
                <br/>
                Below we show the agenda for a typical Rotary Dinner Meeting.
                <br/>
                <br/>
                <ul>
                    <li>Meeting Call to Order, Rotary Grace</li>
                    <li>Welcome by the Club President</li>
                    <li>Introduction of Guests and visiting Rotarians by the President</li>
                    <li><u>Commencement of the Meal.</u> One course only these days. This is an opportunity for members to communicate with each other as to the week’s doings etc.</li>
                    <li><u>Short Talk on aspects of Rotary (5-10 minutes).</u> Rotary is such a diverse organization it is very difficult for Rotarians to be aware of all of its projects and operations – this is an attempt to keep members informed of the major ones, particularly the big, international projects.</li>
                    <li>
                        <u>Service Announcements.</u>There are 5 Committees for the 5 Avenues of Service in Rotary Australia:
                        <ul>
                            <li>Club service</li>
                            <li>Community Service</li>
                            <li>International Service</li>
                            <li>Vocational Service</li>
                            <li>Youth (or New Generations) Service</li>
                        </ul>
                    </li>
                    <li><u>Introduction of Guest Speaker.</u> Guest speakers speak to an Avenue of Service topic or some other topic of interest to Frenchs Forest members.</li>
                    <li>Guest Speaker’s Presentation (typically 30-45 minutes)</li>
                    <li>Questions & Club Thanks for Guest Speaker                    </li>
                </ul>
                <div className="center-container">
                        <img className="rotary-club-image" src="/imgs/gi/regularmeeting2.jpg"/>
                </div>
                <ul>
                    <li>President’s Reminders</li>
                    <li>Close of Meeting – Rotary Toast</li>
                </ul>
            </div>
        </PageContainer>
    </div>
);

export default RegularMeeting;
